import styled from 'styled-components';

export const Wrapper = styled.div`
margin: auto;
width: 100%;
margin-bottom: 160px;
.main-title {
    font-weight: 700;
    font-size: 23px;
    color: white;
    width: 100%;
    @media (max-width: 600px) {
        font-size: 20px;
        text-align: center;
    }
    ${p => p.webConfig.dir === 'ltr' && `
        text-align: left;
    `}
}
.header {
    width: 100%;
    height: 700px;
    background-image: url('/nextasset/images/about/header.jpg');
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 100px;
    background-size: cover;
    background-repeat: no-repeat;
    ${p => p.webConfig.dir === 'ltr' && `
        direction: rtl;
    `}
}
.column-flex {
    margin: right;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 570px;
    @media (max-width: 900px) {
        margin: auto;
    }
    @media (max-width: 600px) {
        width: 100%;
    }
    ${p => p.webConfig.dir === 'ltr' && `
        margin-right: -50px;
    `}
}
.desc {
    font-weight: 500;
    font-size: 16px;
    color: white;
    line-height: 32px;
    margin-top: 20px;
    text-align: justify;
    @media (max-width: 600px) {
        font-size: 15px;
        line-height: 30px;
    }
}
.title {
    font-weight: 600;
    font-size: 18px;
    color: #201E67;
    width: 100%;
    background-color: rgb(233, 247, 245);
    padding: 20px;
    border-radius: 16px;
    @media (max-width: 600px) {
        font-size: 17px;
    }
}
.card {
    width: 800px;
    height: auto;
    box-shadow: 0px 1px 8px rgba(0,0,0,0.25);
    border-radius: 16px;
    margin: auto;
    margin-bottom: 40px;
    @media (max-width: 800px) {
        width: 100%;
    }
}
.subtitle {
    font-weight: 500;
    font-size: 16px;
    color: black;
    line-height: 32px;
    padding: 20px;
    margin-top: -15px;
    text-align: justify;
    @media (max-width: 600px) {
        font-size: 15px;
        line-height: 30px;
    }
}
`